import React from 'react';
import { proxyContextSafeUrl } from '../api';
import type { Props } from './types';

export default function IssueLink(props: Props) {
	const { projectKey, issueKey, className, issueId } = props;
	const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;

	return (
		<a
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			href={proxyContextSafeUrl(`/browse/${fullIssueKey}`)}
			target="_blank"
			rel="noopener noreferrer"
			id={issueId && `issue-link-${issueId}`}
		>
			{props.children || fullIssueKey}
		</a>
	);
}
